import React from 'react'

import { Box, Skeleton } from '@mui/material'

import { theme } from 'styles/theme'

const Loading: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" padding="24px" gap="16px">
      {/* Header */}
      <Box display="flex" alignItems="center" gap="12px">
        <Skeleton
          variant="rounded"
          width={36}
          height={36}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton variant="text" width={100} height={28} />
      </Box>

      {/* Amount Wrapper - Total em aberto / Total pago */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          padding: '16px 20px',
          backgroundColor: theme.palette.neutral[900],
          borderRadius: '12px',
          border: `1px solid ${theme.palette.neutral[700]}`
        }}
      >
        <Box display="flex" alignItems="center" gap="8px">
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={90} height={28} />
        </Box>
        <Box
          sx={{
            height: '32px',
            borderRight: `1px solid ${theme.palette.neutral[600]}`
          }}
        />
        <Box display="flex" alignItems="center" gap="8px">
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={70} height={28} />
        </Box>
      </Box>

      {/* Cards - 3 columns */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '16px',
          width: '100%',
          [theme.breakpoints.down(560)]: {
            gridTemplateColumns: '1fr'
          }
        }}
      >
        {[1, 2, 3].map((i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              padding: '20px',
              borderRadius: '12px',
              border: `1px solid ${theme.palette.neutral[700]}`,
              backgroundColor: theme.palette.neutral[900],
              minHeight: '100px'
            }}
          >
            <Skeleton variant="text" width="60%" height={18} />
            <Skeleton variant="text" width="40%" height={32} />
          </Box>
        ))}
      </Box>

      {/* Table Section */}
      <Box
        sx={{
          padding: '16px',
          borderRadius: '12px',
          border: `1px solid ${theme.palette.neutral[700]}`,
          backgroundColor: theme.palette.neutral[900]
        }}
      >
        {/* Table Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb="16px"
        >
          <Box display="flex" flexDirection="column" gap="4px">
            <Skeleton variant="text" width={100} height={18} />
            <Skeleton variant="text" width={30} height={24} />
          </Box>
          <Box display="flex" gap="8px">
            <Skeleton variant="rounded" width={140} height={36} />
            <Skeleton variant="rounded" width={100} height={36} />
          </Box>
        </Box>

        {/* Table */}
        <Box
          sx={{
            borderRadius: '8px',
            border: `1px solid ${theme.palette.neutral[700]}`,
            overflow: 'hidden'
          }}
        >
          {/* Table Header Row */}
          <Box
            display="flex"
            gap="16px"
            padding="12px 16px"
            sx={{ backgroundColor: theme.palette.neutral[850] }}
          >
            <Skeleton variant="text" width="25%" height={20} />
            <Skeleton variant="text" width="20%" height={20} />
            <Skeleton variant="text" width="20%" height={20} />
            <Skeleton variant="text" width="15%" height={20} />
            <Skeleton variant="text" width="10%" height={20} />
          </Box>
          {/* Table Rows */}
          {[1, 2, 3].map((i) => (
            <Box
              key={i}
              display="flex"
              gap="16px"
              padding="16px"
              sx={{
                borderTop: `1px solid ${theme.palette.neutral[700]}`
              }}
            >
              <Skeleton variant="text" width="25%" height={20} />
              <Skeleton variant="text" width="20%" height={20} />
              <Skeleton variant="text" width="20%" height={20} />
              <Skeleton variant="rounded" width={80} height={28} />
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default Loading
